import { render } from "./surcharge_editor.vue?vue&type=template&id=839e71ee&scoped=true"
import script from "./surcharge_editor.vue?vue&type=script&lang=js"
export * from "./surcharge_editor.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-839e71ee"]])

export default __exports__